import { DEFAULT_TOAST_OPTIONS } from "@/app/models";
import { toast } from "sonner";

const mobileDeviceUserAgentRegex =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

// Basic RTL language detection based on character codes
export const isRtlText = (text: string) => {
  if (typeof text !== "string") {
    return;
  }
  const rtlChars =
    /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g;
  const rtlDirCharsCount = (text.match(rtlChars) || []).length;

  // This is a very basic check and might consider a text as RTL even if it contains a mix of RTL and LTR characters
  return rtlDirCharsCount > text.length - rtlDirCharsCount;
};

// !Avoid isMobileDevice, use useScreen instead
export const isMobileDevice = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const userAgent = navigator.userAgent || navigator.vendor;
  return mobileDeviceUserAgentRegex.test(userAgent);
};

export const copyToClipboard = (text: string, sucessToastMessage?: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast(
        sucessToastMessage || "Text copied to clipboard",
        DEFAULT_TOAST_OPTIONS,
      );
    })
    .catch(() => {
      toast.error("Could not copy text", DEFAULT_TOAST_OPTIONS);
    });
};

export const isFirefox = () => navigator.userAgent.includes("Firefox");

export const timeout = (ms: number) =>
  new Promise<NodeJS.Timeout>((resolve) => setTimeout(resolve, ms));
